import "./fullscreen_gallery.css";
import { gsap } from "gsap";

document.addEventListener(
  "DOMContentLoaded",
  () => {
    const galleries = document.querySelectorAll(".fullscreen_gallery_wrapper");

    galleries.forEach((galleryWrapper) => {
      let current = 0;
      let play = true;
      let interval = 0;
      let tween;

      const gallery = galleryWrapper.querySelectorAll("#fullscreen_gallery")[0];
      const buttons = galleryWrapper.querySelectorAll(
        ".fullscreen_gallery_navigation span",
      );
      const navigation = galleryWrapper.querySelectorAll(
        ".fullscreen_gallery_navigation",
      )[0];
      const items = galleryWrapper.querySelectorAll(".fullscreen_gallery_item");
      const playButton = galleryWrapper.querySelectorAll(
        "#fullscreen_gallery_play",
      )[0];

      if (buttons.length < 2) {
        navigation.classList.add("fullscreen_gallery_navigation_hidden");
        return;
      }
      const removeAllActive = () => {
        buttons.forEach(function (btn, index) {
          btn.classList.remove("fullscreen_gallery_navigation_item_active");
        });
      };

      const setActive = () => {
        if (tween) tween.kill();
        tween = gsap.to(gallery, {
          scrollTo: {
            x: current * items[0].clientWidth,
            autoKill: false,
          },
          duration: 2,
          ease: "power3.inOut",
          onStart: () => {
            removeAllActive();
            if (play) {
              buttons[current].classList.add(
                "fullscreen_gallery_navigation_item_active",
              );
            }
          },
          onComplete: () => {},
        });
      };

      buttons.forEach(function (btn, index) {
        btn.addEventListener("click", function () {
          current = index;
          setActive();
          if (play) {
            stop();
            run();
          }
        });
      });

      const run = () => {
        buttons[current].classList.add(
          "fullscreen_gallery_navigation_item_active",
        );
        interval = setInterval(function () {
          if (play) {
            current = (current + 1) % items.length;
            setActive();
          }
        }, 5000);
      };
      run();

      const stop = () => {
        removeAllActive();
        window.clearInterval(interval);
      };

      playButton.addEventListener("click", () => {
        play = !play;
        playButton.classList.toggle("fullscreen_gallery_stop");
        if (!play) {
          stop();
        } else {
          run();
        }
      });
    });
  },
  false,
);
